import React, { useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import { Fade } from 'react-awesome-reveal';
import { Button } from '../../Button';
import { GameProgressBar } from '../GameProgressBar';
import { Indicator } from '../Indicator';
import CustomModal from '../../Modal';
import { useExternalLink } from '../../../shared/useExternalLink';
import decorImageSrc from '../../../assets/images/prelander/decor.png';
import goldWinnerImageSrc from '../../../assets/images/prelander/gold-winner.png';
import starImageSrc from '../../../assets/images/prelander/star-pic.png';
import sRatingImageSrc from '../../../assets/images/prelander/s-rating.png';
import sImageSrc from '../../../assets/images/prelander/s-rating-pic.png';
import aRatingImageSrc from '../../../assets/images/prelander/a-rating.png';
import aImageSrc from '../../../assets/images/prelander/a-rating-pic.png';
import aPlusRatingImageSrc from '../../../assets/images/prelander/a-plus-rating.png';
import aPlusImageSrc from '../../../assets/images/prelander/a-plus-rating-pic.png';
import styles from './GoldStage.css';

const cx = classnames.bind(styles);

const STAR_PICK_MODAL = 'starPickModal';
const RESULT_MODAL = 'resultModal';

function GoldStage({cards, selectStarRole, selectedStarRole, teamPowerScore, teamPowerScoreWithStarRole, restart}) {
    const [isFinish, setIsFinish] = useState(false);
    const [modal, setModal] = useState({type: STAR_PICK_MODAL});
    const [isAnimateModalContent, setIsAnimateModalContent] = useState(false);
    const {url: subscriptionUrl, onClick: clickOnClaimRewards} = useExternalLink('subscription/v4', 'freeRegistration=true');

    useEffect(() => {
        if (!isFinish) {
            if (modal.type === STAR_PICK_MODAL) {
                setIsAnimateModalContent(true);

                setTimeout(() => {
                    setIsAnimateModalContent(false);
                }, 1500);

                setTimeout(() => {
                    setModal({type: ''});
                }, 2000);
            }
        }
    }, []);

    const getResultImages = () => {
        if (teamPowerScoreWithStarRole > 95) {
            return {
                ratingImageUrl: sRatingImageSrc,
                imageUrl: sImageSrc
            }
        }

        if (teamPowerScoreWithStarRole > 90 && teamPowerScoreWithStarRole <= 95) {
            return {
                ratingImageUrl: aPlusRatingImageSrc,
                imageUrl: aPlusImageSrc
            }
        }

        return {
            ratingImageUrl: aRatingImageSrc,
            imageUrl: aImageSrc
        }
    };

    const renderStar = role => {
        if (role === selectedStarRole) {
            return (
                <div className={cx('starBlock', 'active')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none" viewBox="0 0 44 44" className={styles.starBlockBorder}>
                        <rect width="43" height="43" x=".5" y=".5" stroke="url(#starBlockBorder1)" rx="21.5"/><defs><linearGradient id="starBlockBorder1" x1="0" x2="44" y1="0" y2="44" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA300"/><stop offset=".481" stop-color="#FFA300" stop-opacity="0"/><stop offset="1" stop-color="#FFA300"/></linearGradient></defs>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none" viewBox="0 0 54 54" className={styles.starBlockIcon}>
                        <g filter="url(#a)">
                        <path fill="url(#b)" d="m27 19 2.472 5.266 5.528.85-4 4.096.944 5.788L27 32.266 22.056 35 23 29.212l-4-4.096 5.528-.85L27 19Z"/></g><defs><linearGradient id="b" x1="19" x2="46.909" y1="35" y2="35" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA300"/><stop offset="1" stop-color="#FF5B00"/></linearGradient>
                        <filter id="a" width="54" height="54" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.36 0 0 0 0 0 0 0 0 1 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_21153_163035"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feMorphology in="SourceAlpha" operator="dilate" radius="1" result="effect2_dropShadow_21153_163035"/><feOffset/><feGaussianBlur stdDeviation="9"/><feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.356863 0 0 0 0 0 0 0 0 1 0"/><feBlend in2="effect1_dropShadow_21153_163035" result="effect2_dropShadow_21153_163035"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend in2="effect2_dropShadow_21153_163035" result="effect3_dropShadow_21153_163035"/><feBlend in="SourceGraphic" in2="effect3_dropShadow_21153_163035" result="shape"/></filter></defs>
                    </svg>
                </div>
            )
        };

        return (
            <div
                className={styles.starBlock}
                onClick={() => selectStarRole(role)}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none" viewBox="0 0 44 44" className={styles.starBlockBorder}>
                    <rect width="43" height="43" x=".5" y=".5" stroke="url(#starBlockBorder2)" rx="21.5"/><defs><linearGradient id="starBlockBorder2" x1="0" x2="44" y1="0" y2="44" gradientUnits="userSpaceOnUse"><stop stop-color="#94A5CD"/><stop offset=".481" stop-color="#94A5CD" stop-opacity="0"/><stop offset="1" stop-color="#94A5CD"/></linearGradient></defs>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.starBlockIcon}>
                    <path d="M8 0L10.472 5.26604L16 6.11567L12 10.2124L12.944 16L8 13.266L3.056 16L4 10.2124L0 6.11567L5.528 5.26604L8 0Z" fill="#94A5CD"/>
                </svg>
            </div>
        );
    };

    const openResultModal = () => {
        setModal({type: RESULT_MODAL});
        setTimeout(() => {
            setIsAnimateModalContent(true);
        }, 0);
    };

    const handleFinish = () => {
        setTimeout(() => {
            setIsAnimateModalContent(false);
        }, 0);

        setTimeout(() => {
            setModal({type: ''});
        }, 500);

        setIsFinish(true);
    };

    const renderContent = () => {
        if (isFinish) {
            return (
                <div className={cx('content', 'finish')}>
                    <GameProgressBar
                        progressList={[100, 100, 100]}
                    />
                    <Fade
                        duration={500}
                        className={styles.wrapper}
                        triggerOnce
                    >
                        <img
                            src={`${goldWinnerImageSrc}?v=3`}
                            alt='gold'
                            className={styles.imageWinner}
                        />
                    </Fade>
                    <div className={styles.footerFinish}>
                        <Button
                            label='Сlaim all rewards'
                            link={{
                                to: subscriptionUrl,
                                target: 'custom'
                            }}
                            className={styles.fullButton}
                            onClick={clickOnClaimRewards}
                        />
                    </div>
                </div>
            );
        };

        const [primaryCard, secondaryCard, tertiaryCard] = cards;

        return (
            <Fade
                duration={500}
                className={styles.content}
                triggerOnce
            >
                <div className={styles.contentWithFlex}>
                    <GameProgressBar
                        progressList={[100, 100, 5]}
                        className={styles.progressBarWrapper}
                    />
                    <div className={styles.cards}>
                        {cards.map(card => (
                            <div
                                className={styles.card}
                                key={card.id}
                            >
                                {renderStar(card.role)}
                                <img
                                    src={card.imageUrl}
                                    alt={card.name}
                                    className={styles.cardImage}
                                />
                            </div>
                        ))}
                    </div>
                    <div className={styles.scoresBlock}>
                        <div className={styles.scoresBlockItem}>
                            <span className={styles.scoresBlockItemLabel}>Captain</span>
                            <Indicator
                                value={primaryCard.captainRoleScore * 10}
                            />
                        </div>
                        <div className={styles.scoresBlockItem}>
                            <span className={styles.scoresBlockItemLabel}>Shooter</span>
                            <Indicator
                                value={secondaryCard.shooterRoleScore * 10}
                            />
                        </div>
                        <div className={styles.scoresBlockItem}>
                            <span className={styles.scoresBlockItemLabel}>Defender</span>
                            <Indicator
                                value={tertiaryCard.defenderRoleScore * 10}
                            />
                        </div>
                    </div>
                    <div className={styles.controlsBlock}>
                        <div className={styles.teamPower}>
                            <p className={styles.teamPowerTitle}>Your team power</p>
                            <Indicator
                                value={teamPowerScore}
                                incValue={Math.round(teamPowerScore * (cards.find(card => card.role === selectedStarRole)?.captainRoleScore || 0) * 2.1 / 100)}
                                height={8}
                            />
                        </div>
                        {Boolean(selectedStarRole) && (
                            <Button
                                label='Continue'
                                onClick={openResultModal}
                                className={styles.controlButton}
                            />
                        )}
                    </div>
                </div>
            </Fade>
        );
    };

    return (
        <>
            {renderContent()}
            <CustomModal
                isOpen={modal.type === STAR_PICK_MODAL}
                onCloseModal={() => {}}
                overlayClassName={styles.overlay}
                className={styles.modal}
            >
                <img
                    src={starImageSrc}
                    alt='star'
                    className={cx('modalImage', {withAnimation: isAnimateModalContent})}
                />
                <div className={cx('modalWrapper', {withAnimation: isAnimateModalContent})}>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'top')}
                    />
                    <span className={cx('modalText', 'modalTextUppercase')}>Pick the star player for bonus points</span>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'bottom')}
                    />
                </div>
                <div className={styles.modalImage} />
            </CustomModal>
            <CustomModal
                isOpen={modal.type === RESULT_MODAL}
                onCloseModal={() => {}}
                overlayClassName={styles.overlay}
                className={styles.modal}
            >
                <img
                    src={getResultImages().imageUrl}
                    alt='rating image'
                    className={cx('modalImage', {withAnimation: isAnimateModalContent})}
                />
                <div className={cx('modalWrapper', {withAnimation: isAnimateModalContent})}>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'top')}
                    />
                    <span className={cx('modalText', 'modalTextUppercase')}>Your final team power is</span>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'bottom')}
                    />
                    <div className={styles.teamPowerFinalBlock}>
                        <p><span>{teamPowerScoreWithStarRole}</span></p>
                        <p><span>of</span></p>
                        <p><span>100</span></p>
                    </div>
                    <img
                        src={getResultImages().ratingImageUrl}
                        className={styles.ratingImage}
                        alt='rating'
                    />
                </div>
                <div className={styles.modalImage} />
                <div className={cx('modalFooter', 'withChildren')}>
                    <Button
                        label='Continue'
                        onClick={handleFinish}
                    />
                    <Button
                        label='Try again'
                        onClick={restart}
                        className={styles.secondaryButton}
                        type='secondary'
                    />
                </div>
            </CustomModal>
        </>
    )
}

export {
    GoldStage
}
